module.exports = __webpack_public_path__ + "72a615fa1350c9a00df23d9cb086dc96.png";